import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AdminPanel.css';

function AdminPanel() {
  const [eventId, setEventId] = useState('hartmans-04-22-2026');
  const [isActive, setIsActive] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Load current active event from localStorage
    const activeEventId = localStorage.getItem('active-event-id');
    if (activeEventId) {
      setEventId(activeEventId);
      setIsActive(true);
    }
  }, []);

  const handleActivateEvent = () => {
    if (!eventId.trim()) {
      setMessage('Please enter an event ID');
      return;
    }

    localStorage.setItem('active-event-id', eventId.trim());
    setIsActive(true);
    setMessage(`Event "${eventId}" is now active!`);

    setTimeout(() => setMessage(''), 3000);
  };

  const handleDeactivateEvent = () => {
    localStorage.removeItem('active-event-id');
    setEventId('');
    setIsActive(false);
    setMessage('Event deactivated');

    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div className="admin-panel-container">
      <div className="admin-panel-content">
        <div className="admin-header">
          <h1>Admin Panel</h1>
          <Link to="/" className="home-link">← Home</Link>
        </div>

        <div className="admin-card">
          <h2>Event Configuration</h2>

          <div className="form-group">
            <label htmlFor="event-id">Event ID</label>
            <input
              id="event-id"
              type="text"
              value={eventId}
              onChange={(e) => setEventId(e.target.value)}
              placeholder="e.g., valentine-2026-buffalo"
              disabled={isActive}
              className="event-input"
            />
          </div>

          <div className="status-indicator">
            <span className={`status-dot ${isActive ? 'active' : 'inactive'}`}></span>
            <span className="status-text">
              {isActive ? `Event Active: ${eventId}` : 'No Active Event'}
            </span>
          </div>

          <div className="button-group">
            {!isActive ? (
              <button
                onClick={handleActivateEvent}
                className="btn btn-primary"
                disabled={!eventId.trim()}
              >
                Activate Event
              </button>
            ) : (
              <button
                onClick={handleDeactivateEvent}
                className="btn btn-danger"
              >
                Deactivate Event
              </button>
            )}
          </div>

          {message && (
            <div className={`message ${isActive ? 'success' : 'info'}`}>
              {message}
            </div>
          )}
        </div>

        <div className="admin-card">
          <h2>Quick Links</h2>
          <div className="quick-links">
            <Link to="/sign-in" className="quick-link">
              Sign In Page →
            </Link>
            <Link to="/games" className="quick-link">
              Games →
            </Link>
          </div>
        </div>

        <div className="admin-info">
          <p><strong>Note:</strong> This is a basic admin panel shell. Features like event details, image upload, and real-time vote tracking will be added in a separate implementation.</p>
          <p><strong>Auth:</strong> Integration with thrybr-auth service will be added separately.</p>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
